export const images = {
  bgMain: require("../Assets/bg.jpg"),
  logo: require("../Assets/logo.png"),
  gvNam: require("../Assets/gvNam.png"),
  gvNu: require("../Assets/gvNu.png")
};
